import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from './i18n.service';
import { ConfigI18n } from './i18n.model';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    I18nService
  ]
})
export class I18nModule {
}
